<div [className]="'create-reservation step-' + reservationStep">
  <ng-container *ngIf="reservationForm" [formGroup]="reservationForm">
    <ng-container [ngSwitch]="reservationStep">
      <div *ngSwitchCase="1" class="reservation-step">
        <div *ngIf="admin">
          <button  mat-raised-button
                   color="accent"
                   class="reservation-btn"
                   [disabled]="isRestaurant"
                   (click)="reservationInLocal()">{{ 'reservations.reservationLocal' | translate }}</button>
          <button mat-raised-button
                  color="accent"
                  class="reservation-btn"
                  [disabled]="!isRestaurant"
                  (click)="reservationInGarden()">{{ 'reservations.reservationGarden' | translate }}</button>
        </div>
        <h1>
          {{ 'reservations.title' | translate }}<ng-container *ngIf="admin && !isRestaurant"> {{ 'reservations.tableInGarden' | translate }}<br></ng-container>
        </h1>

        <div class="reservation-time">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'reservations.date' | translate }}</mat-label>
            <mat-select
              formControlName="dateDay"
              panelClass="reservation-select"
              [disableOptionCentering]="true"
              [compareWith]="dateCompareFunc"
            >
              <mat-option
                *ngFor="let option of daysOptions"
                [value]="option.value"
                >{{ option.label }}</mat-option
              >
            </mat-select> </mat-form-field
          ><mat-form-field appearance="outline">
            <mat-label>{{ 'reservations.time' | translate }}</mat-label>
            <mat-select
              formControlName="startDate"
              panelClass="reservation-select"
              [disableOptionCentering]="true"
              [compareWith]="dateCompareFunc"
            >
              <mat-option
                *ngFor="let option of hoursOptions"
                [value]="option.value"
                >{{ option.label }}</mat-option
              >
            </mat-select> </mat-form-field
          ><mat-form-field *ngIf="admin" appearance="outline">
            <mat-label>{{ 'reservations.endTime' | translate }}</mat-label>
            <mat-select
              formControlName="endDate"
              panelClass="reservation-select"
              [disableOptionCentering]="true"
              [compareWith]="dateCompareFunc"
            >
              <mat-option
                *ngFor="let option of endHoursOptions"
                [value]="option.value"
                >{{ option.label }}</mat-option
              >
            </mat-select> </mat-form-field
          ><mat-form-field *ngIf="admin" appearance="outline"  class="two-row-label">
            <mat-label [innerHTML]="'reservations.seatsLabel' | translate"></mat-label>
            <input
              matInput
              type="number"
              min="1"
              max="8"
              formControlName="guestsAmount"
              panelClass="reservation-select"
            />
          </mat-form-field
          ><mat-form-field *ngIf="admin" appearance="outline" class="two-row-label">
            <mat-label>{{ 'reservations.tableModeLabel' | translate }}</mat-label>
            <mat-select
              [value]="adminTableMode"
              (selectionChange)="setAdminTableMode($event.value)"
              panelClass="reservation-select"
              [disableOptionCentering]="true"
            >
              <mat-option value="manual">{{ 'reservations.tableModeManual' | translate }}</mat-option>
              <mat-option value="auto">{{ 'reservations.tableModeAuto' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field *ngIf="!admin" appearance="outline">
            <mat-label>{{ 'reservations.guestsCount' | translate }}</mat-label>
            <mat-select
              formControlName="guestsAmount"
              panelClass="reservation-select"
              [disableOptionCentering]="true"
            >
              <mat-option
                *ngFor="let count of guestsAmountOptions"
                [value]="count"
                >{{ count }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Admin: rzut sali (tylko przy ręcznym wyborze stolika) -->
        <app-reservation-map *ngIf="admin && adminTableMode === 'manual' && (isRestaurant || isGardenOpen)" [isRestuarant]="isRestaurant" [tables]="tables">
          <div class="errors">
            <mat-error *ngIf="reservationForm.getError('guestsAmount')?.min">{{ 'reservations.selectOneTable' | translate }}</mat-error>
            <mat-error *ngIf="reservationForm.getError('guestsAmount')?.max">{{ 'reservations.selectFewerTables' | translate }}<br>{{ 'reservations.contactManager' | translate }}<br>603 900 600 lub manager@drzewowisni.pl</mat-error>
            <mat-error *ngIf="isHasGapError">{{ 'reservations.gapError' | translate }}</mat-error>
          </div>
        </app-reservation-map>

        <!-- Admin: wynik automatycznego doboru stolika -->
        <div class="admin-auto-tables" *ngIf="admin && adminTableMode === 'auto' && (isRestaurant || isGardenOpen)">
          <div class="auto-assigned" *ngIf="!adminAutoAssignError && getSelectedTableNumbers()">
            {{ 'reservations.autoAssignedTables' | translate }}
            <strong>{{ getSelectedTableNumbers() }}</strong>
          </div>
          <mat-error *ngIf="adminAutoAssignError">{{ 'reservations.autoAssignFailed' | translate }}</mat-error>
        </div>

        <div class="garden-is-closed" *ngIf="admin && (!isRestaurant && !isGardenOpen)">
          <div>{{ 'reservations.gardenClosed' | translate }}</div>
        </div>

        <!-- Klient: wybór miejsca + komunikat dostępności -->
        <div *ngIf="!admin" class="availability-message">
          <ng-container [ngSwitch]="availabilityState">
            <div *ngSwitchCase="'searching'" class="availability-info searching">
              {{ 'reservations.checkingAvailability' | translate }}
            </div>

            <ng-container *ngSwitchCase="'available'">
              <!-- Miejsce ustalone na ekranie startowym (Lokal/Ogródek) — bez
                   ponownego wyboru. Pokazujemy tylko status dostępności. -->
              <div class="availability-info available">
                <ng-container *ngIf="!availabilityIsGarden">
                  {{ 'reservations.tableAvailableLocal' | translate }}
                </ng-container>
                <ng-container *ngIf="availabilityIsGarden">
                  {{ 'reservations.tableAvailableGarden' | translate }}
                </ng-container>
              </div>
            </ng-container>

            <div *ngSwitchCase="'not_available'" class="availability-info not-available">
              <p>{{ 'reservations.tableNotAvailable' | translate }}</p>
              <ng-container *ngIf="nextAvailableSlot as slot">
                <p>
                  {{ (suggestedSlotIsEarlier() ? 'reservations.earlierSlotPrefix' : 'reservations.nextAvailableSlotPrefix') | translate }}
                  <strong>
                    <ng-container [ngSwitch]="getDayLabelForMessage(slot.date).key">
                      <ng-container *ngSwitchCase="'today'">{{ 'reservations.today' | translate }}</ng-container>
                      <ng-container *ngSwitchCase="'tomorrow'">{{ 'reservations.tomorrow' | translate }}</ng-container>
                      <ng-container *ngSwitchCase="'date'">{{ getDayLabelForMessage(slot.date).value }}</ng-container>
                    </ng-container>
                    {{ 'reservations.atTime' | translate }} {{ formatReservationTimeWarsaw(slot.startDate) }}
                    <ng-container *ngIf="slot.isGarden">
                      ({{ 'reservations.locationGarden' | translate }})
                    </ng-container>
                    <ng-container *ngIf="!slot.isGarden">
                      ({{ 'reservations.locationLocal' | translate }})
                    </ng-container>
                  </strong>.
                </p>
                <p>{{ 'reservations.nextAvailableSlotHint' | translate }}</p>
                <button mat-raised-button color="accent" class="use-slot-btn" (click)="applyNextAvailableSlot()">
                  {{ 'reservations.useThisSlot' | translate }}
                </button>
              </ng-container>
            </div>
            <div *ngSwitchCase="'no_availability_in_period'" class="availability-info not-available">
              {{ 'reservations.noAvailabilityInPeriod' | translate }}
            </div>
          </ng-container>
        </div>

        <div class="main-container">
          <div class="main-container--row" [ngClass]="{'justify-center': true}">
            <div class="main-container--row main-col-6 main-col-lg-6 main-col-md-6 main-col-sm-12 main-col-xs-12 res-btn-container justify-center">
              <button
                *ngIf="admin"
                mat-raised-button
                color="accent"
                class="reservation-btn reservation-btn-center button-translate"
                [disabled]="
            reservationForm.getError('guestsAmount') !== null ||
            !reservationForm.get('startDate')?.valid
            || hoursOptions.length === 0
            || isHasGapError
          "
                (click)="nextStep()"
              >
                {{ 'common.bookNow' | translate }}
              </button>
              <button
                *ngIf="!admin"
                mat-raised-button
                color="accent"
                class="reservation-btn reservation-btn-center button-translate"
                [disabled]="availabilityState !== 'available'"
                (click)="nextStep()"
              >
                {{ 'common.bookNow' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="2" class="reservation-step">
        <h1>{{ 'reservations.contactDetails' | translate }}</h1>
        <div class="reservation-data">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'reservations.firstName' | translate }}</mat-label>
            <input formControlName="firstName" matInput /> </mat-form-field
          ><mat-form-field appearance="outline">
            <mat-label>{{ 'reservations.lastName' | translate }}</mat-label>
            <input formControlName="surname" matInput /> </mat-form-field
          >
          <div class="container">
            <mat-form-field appearance="outline" class="code" *ngIf="!admin">
              <mat-label>{{ 'reservations.countryCode' | translate }}</mat-label>
              <input matInput formControlName="code" [matAutocomplete]="auto" [placeholder]="'reservations.countryCodePlaceholder' | translate">
              <mat-autocomplete
                #auto="matAutocomplete" (optionSelected)="onSelect($event)"
                panelClass="reservation-select">
                <mat-option *ngFor="let phone of filteredCodeNumber | async" [value]="phone.code">
                  {{ phone.code }} {{ phone.country }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" class="phone" [ngClass]="{'admin-phone': admin}">
              <mat-label>{{ 'reservations.phoneNumber' | translate }}</mat-label>
              <input
                type="tel"
                formControlName="phoneNumber"
                matInput
                [placeholder]="'reservations.phonePlaceholder' | translate"/>
              <mat-hint *ngIf="!admin">{{ 'reservations.phoneHint' | translate }}</mat-hint>
              <mat-error style="color: white" *ngIf="reservationForm.controls['phoneNumber'].hasError('startWith')">
                {{ 'reservations.phoneError' | translate }}
              </mat-error>
              <mat-error style="color: white" *ngIf="reservationForm.controls['phoneNumber'].hasError('minlength') && !reservationForm.controls['phoneNumber'].hasError('startWith')">
                {{ 'reservations.phoneMinLengthError' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

        </div>
        <div class="reservation-data">
          <mat-form-field appearance="outline" *ngIf="!admin" class="full-width-field">
            <mat-label>{{ 'reservations.emailLabel' | translate }}</mat-label>
            <input formControlName="email" type="email" matInput [placeholder]="'reservations.emailPlaceholder' | translate" />
            <mat-error style="color: white" *ngIf="reservationForm.controls['email'].hasError('required')">
              {{ 'reservations.emailRequired' | translate }}
            </mat-error>
            <mat-error style="color: white" *ngIf="reservationForm.controls['email'].hasError('email') && !reservationForm.controls['email'].hasError('required')">
              {{ 'reservations.emailInvalid' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="reservation-data">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'reservations.comment' | translate }}</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              formControlName="comment"
            ></textarea>
          </mat-form-field>
        </div>
        <div class="marketing-consent" *ngIf="!admin">
          <mat-checkbox formControlName="marketingConsent" color="accent">
            <span [innerHTML]="'reservations.marketingConsent' | translate"></span>
          </mat-checkbox>
        </div>
        <div class="marketing-consent" *ngIf="!admin">
          <mat-checkbox formControlName="termsAccepted" color="accent">
            <span [innerHTML]="'reservations.termsAccept' | translate"></span>
          </mat-checkbox>
        </div>
        <div class="button-step">
          <button class="button-translate min-width-100" mat-raised-button (click)="previousStep()">{{ 'common.back' | translate }}</button
          ><button
            class="button-translate min-width-100"
            mat-raised-button
            color="accent"
            [disabled]="
              !reservationForm.get('firstName')?.valid ||
              !reservationForm.get('surname')?.valid ||
              !reservationForm.get('email')?.valid ||
              !reservationForm.get('phoneNumber')?.valid ||
              !reservationForm.get('code')?.valid ||
              (!admin && !reservationForm.get('termsAccepted')?.value)
            "
            (click)="nextStep()"
          >
            {{ 'common.next' | translate }}
          </button>
        </div>
      </div>
      <div *ngSwitchCase="3" class="reservation-step">
        <h1>{{ 'reservations.confirmTitle' | translate }}</h1>


        <div class="reservation-summary">
          <span
            >{{ reservationForm.getRawValue().firstName }}
            {{ reservationForm.getRawValue().surname }}
          </span>
          <span>
            {{ formatReservationDateWarsaw(reservationForm.getRawValue().startDate) }}
          </span>
          <span>
            {{ 'reservations.hour' | translate }}
            {{ formatReservationTimeWarsaw(reservationForm.getRawValue().startDate) }}
          </span>
          <span>
            {{ 'reservations.tel' | translate }}
            {{ reservationForm.getRawValue().code + ' ' }}

            {{ reservationForm.getRawValue().phoneNumber }}
          </span>
          <span *ngIf="reservationForm.getRawValue().email">
            {{ 'reservations.email' | translate }}
            {{ reservationForm.getRawValue().email }}
          </span>
          <span>
            {{ reservationForm.getRawValue().guestsAmount }}
            {{ 'reservations.persons' | translate }}
          </span>
        </div>
        <mat-progress-bar
          class="example-margin"
          *ngIf="sendingReservation"
          color="accent"
          mode="indeterminate"
        >
        </mat-progress-bar>
        <div class="button-step" *ngIf="!sendingReservation">
          <button class="button-translate min-width-100" mat-raised-button (click)="previousStep()">{{ 'common.back' | translate }}</button
          ><button class="button-translate" mat-raised-button color="accent" (click)="sendReservation()">
            {{ 'reservations.confirmReservation' | translate }}
          </button>
        </div>
      </div>
      <div *ngSwitchDefault class="reservation-step">
        <h1>{{ 'reservations.tableReserved' | translate }}</h1>
        <ng-content></ng-content>
      </div>
    </ng-container>
  </ng-container>
</div>
